const usersData = [
  { subject: 'Lorem Ipsum', announcment: '', role: 'Member', status: 'Active'},
  { subject: 'Lorem ipsum', announcment: '', role: 'Member', status: 'Inactive'},
  { subject: 'Lorem Ipsum', announcment: '', role: 'Member', status: 'Active'},
  { subject: 'Lorem ipsum', announcment: '', role: 'Member', status: 'Inactive'},
  { subject: 'Lorem Ipsum', announcment: '', role: 'Member', status: 'Active'},
  { subject: 'Lorem Ipsum', announcment: '', role: 'Member', status: 'Active'},
  { subject: 'Lorem Ipsum', announcment: '', role: 'Member', status: 'Active'},
  { subject: 'Lorem Ipsum', announcment: '', role: 'Member', status: 'Active'},
  { subject: 'Lorem Ipsum', announcment: '', role: 'Member', status: 'Active'},
  { subject: 'Lorem ipsum', announcment: '', role: 'Member', status: 'Inactive'},
  { subject: 'Lorem Ipsum', announcment: '', role: 'Member', status: 'Active'},
  { subject: 'Lorem ipsum', announcment: '', role: 'Member', status: 'Inactive'},
  { subject: 'Lorem Ipsum', announcment: '', role: 'Member', status: 'Active'},
  { subject: 'Lorem Ipsum', announcment: '', role: 'Member', status: 'Active'},
  { subject: 'Lorem Ipsum', announcment: '', role: 'Member', status: 'Active'},
  { subject: 'Lorem Ipsum', announcment: '', role: 'Member', status: 'Active'},
  { subject: 'Lorem Ipsum', announcment: '', role: 'Member', status: 'Active'},
  { subject: 'Lorem ipsum', announcment: '', role: 'Member', status: 'Inactive'},
  { subject: 'Lorem Ipsum', announcment: '', role: 'Member', status: 'Active'},
  { subject: 'Lorem ipsum', announcment: '', role: 'Member', status: 'Inactive'},
  { subject: 'Lorem Ipsum', announcment: '', role: 'Member', status: 'Active'},

 


]

export default usersData


